import CityPage from "../CityPage";
import { citiesData } from "@/mocks/cities";

export default function CityCergyPage() {
  const data = citiesData.find((c) => c.slug === "cergy")!;
  return <CityPage data={data} />;
}
